import React from 'react';

const Unavailable = ({ title, boxText }) => {
  return (
    <div>
      <button
        type="button"
        className="btn btn-lg btn-danger btn-block"
        disabled
      >
        {title}
      </button>
      <br />
      <div className="alert alert-warning" role="alert">
        <button type="button" className="close" data-dismiss="alert" />
        <strong>{title}</strong>
        <br />
        {boxText}
      </div>
    </div>
  );
};

export default Unavailable;
